export default __webpack_public_path__ + "static/media/referral_bonuses.70285a95.svg";